import createMetadataAPISelectors from '../../utils/api-metadata-selectors';

const options = {
  name: 'certifications',
  baseType: 'CERTIFICATIONS',
  apiEndpoint: 'certifications'
};

const metadataApiSelectors = createMetadataAPISelectors(options);

const certificationsByMembershipAndSkillId = state => state.certifications.byMembershipAndSkillId;

export default {
  ...metadataApiSelectors,
  certificationsByMembershipAndSkillId
};
